export default (element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement): void => {
  const containerEl = element.closest('.o-form__block')

  if (!containerEl) {
    return
  }

  const labelEl = containerEl.querySelector('.o-form__label')
  let isDirty = false

  const markDirty = (): void => {
    if (isDirty) {
      return
    }
    isDirty = true
    labelEl?.setAttribute('data-dirty', 'true')
  }

  const updateErrorVisibility = (isInvalid: boolean): void => {
    const wrapperEl = containerEl.closest('.o-form__field-wrapper')
    if (!wrapperEl) {
      return
    }
    const errorEl = wrapperEl.querySelector('.o-form__field-wrapper-message--error')
    if (!errorEl) {
      return
    }
    errorEl.setAttribute('aria-hidden', isInvalid ? 'false' : 'true')
  }

  const focusBlockFn = function (this: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement): void {
    containerEl.classList.add('o-form__field--focused')
    labelEl?.setAttribute('data-focus', 'true')
  }

  const filledBlockFn = function (this: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement): void {
    containerEl.classList.remove('o-form__field--focused')
    labelEl?.setAttribute('data-focus', 'false')

    setTimeout(() => {
      if (this.value === '') {
        containerEl.classList.remove('o-form__field--filled')
      } else {
        containerEl.classList.add('o-form__field--filled')
      }
    }, 0)
  }

  const checkFieldValidityFn = function (this: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement): void {
    if (!element.checkValidity) {
      return
    }

    markDirty()

    const validity = element.checkValidity()

    if (containerEl && validity) {
      containerEl.classList.remove('o-form__field--invalid')
      containerEl.classList.add('o-form__field--valid')
      element.removeAttribute('aria-invalid')
      labelEl?.setAttribute('data-invalid', 'false')
    } else if (containerEl && !validity) {
      containerEl.classList.remove('o-form__field--valid')
      containerEl.classList.add('o-form__field--invalid')
      element.setAttribute('aria-invalid', 'true')
      labelEl?.setAttribute('data-invalid', 'true')
    }

    updateErrorVisibility(!validity)
  }

  element.addEventListener('click', focusBlockFn)

  element.addEventListener('focus', focusBlockFn)

  element.addEventListener('blur', filledBlockFn)
  element.addEventListener('blur', checkFieldValidityFn)

  element.addEventListener('change', filledBlockFn)
  element.addEventListener('change', checkFieldValidityFn)
}
